
const AgencyEnrolmentBehaviour = props => {

  //console.log(props)
  const {
    value,
  } = props


  const enrolmentType = tangibleFields.render({
    type: 'radio',
    name: 'tgbl_cred_agency_enrolment_type',
    value: value.enrolment_type,
    label: 'User Validation',
    choices: {
      automatic: 'Automatic',
      manual: 'Manual',
      request:'Request Based (no Enroll button on the frontend)'
    },
  })

  return (
    <>
      <div className="tgbl-agency-enrollment-type tgbl-field-block">
        { enrolmentType }
      </div>
    </>
  )
}

export { AgencyEnrolmentBehaviour }
